/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WizardPreviewSummaryDto
 */
export interface WizardPreviewSummaryDto {
    /**
     * 
     * @type {number}
     * @memberof WizardPreviewSummaryDto
     */
    taskCount: number;
    /**
     * 
     * @type {number}
     * @memberof WizardPreviewSummaryDto
     */
    requestedAssetCount: number;
    /**
     * 
     * @type {number}
     * @memberof WizardPreviewSummaryDto
     */
    conflictCount: number;
    /**
     * 
     * @type {number}
     * @memberof WizardPreviewSummaryDto
     */
    replaceCount: number;
    /**
     * 
     * @type {number}
     * @memberof WizardPreviewSummaryDto
     */
    createAssignmentCount: number;
}

/**
 * Check if a given object implements the WizardPreviewSummaryDto interface.
 */
export function instanceOfWizardPreviewSummaryDto(value: object): value is WizardPreviewSummaryDto {
    if (!('taskCount' in value) || value['taskCount'] === undefined) return false;
    if (!('requestedAssetCount' in value) || value['requestedAssetCount'] === undefined) return false;
    if (!('conflictCount' in value) || value['conflictCount'] === undefined) return false;
    if (!('replaceCount' in value) || value['replaceCount'] === undefined) return false;
    if (!('createAssignmentCount' in value) || value['createAssignmentCount'] === undefined) return false;
    return true;
}

export function WizardPreviewSummaryDtoFromJSON(json: any): WizardPreviewSummaryDto {
    return WizardPreviewSummaryDtoFromJSONTyped(json, false);
}

export function WizardPreviewSummaryDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WizardPreviewSummaryDto {
    if (json == null) {
        return json;
    }
    return {
        
        'taskCount': json['taskCount'],
        'requestedAssetCount': json['requestedAssetCount'],
        'conflictCount': json['conflictCount'],
        'replaceCount': json['replaceCount'],
        'createAssignmentCount': json['createAssignmentCount'],
    };
}

export function WizardPreviewSummaryDtoToJSON(json: any): WizardPreviewSummaryDto {
    return WizardPreviewSummaryDtoToJSONTyped(json, false);
}

export function WizardPreviewSummaryDtoToJSONTyped(value?: WizardPreviewSummaryDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'taskCount': value['taskCount'],
        'requestedAssetCount': value['requestedAssetCount'],
        'conflictCount': value['conflictCount'],
        'replaceCount': value['replaceCount'],
        'createAssignmentCount': value['createAssignmentCount'],
    };
}

